import React from "react";

import Collapse from "@churchofjesuschrist/eden-collapse";
import {
  backgroundColorLevelCurrent,
  borderColorTertiary,
  spacing16 as helpPadding,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import HelpArticleLoader from "../../../help/help-article-loader/help-article-loader";
import HelpContentsService from "../../../help/help-contents-service";

//running client side only, so this is
const service = new HelpContentsService();
const loader = {
  get: async (name) => {
    try {
      const data = await service.GetHelpArticle(name);
      return data;
    } catch (e) {
      console.log(`get help article: ${e}`);
      throw e;
    }
  },
};

const helpHeight = 400;
const helpTextHeight = helpHeight - 92;
const HelpContainer = styled.div`
  padding: ${helpPadding} 0;
  background-color:${({isMobile}) => isMobile ? backgroundColorLevelCurrent : borderColorTertiary};
  max-height: ${helpHeight}px;
`;

const normalMaxHeight = `max-height: ${helpTextHeight}px;`;
const HelpTextContainer = styled.div`
  padding: ${helpPadding};
  margin-top: ${helpPadding};
  overflow-y: auto;
  ${({isMobile}) => !isMobile ? normalMaxHeight : ""}
`;

const HelpArticle = ({ helpArticle, isMobile = false }) =>
  helpArticle ? (
    <Collapse expand={true}>
      <HelpContainer isMobile={isMobile}>
        <HelpTextContainer isMobile={isMobile} data-id="page-help-text">
          <HelpArticleLoader
            loader={loader}
            article={helpArticle}
          />
        </HelpTextContainer>
      </HelpContainer>
    </Collapse>
  ) : null;

export default HelpArticle;

